import styled from "styled-components";
import {Typography} from "@mui/material";

export const OptimizerContainer = styled.div`
    background-color: #f9f9f9;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 1.5rem;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
`;

export const OptimizerTitle = styled(Typography)`
    font-weight: bold;
    font-size: 1.5rem;
    margin-bottom: 1rem;
`;

export const OptimizationItem = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: 1.25rem;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StatusIcon = styled.div<{ status: 'optimized' | 'improvement' }>`
    margin-right: 1rem;
    display: flex;
    align-items: center;
    svg {
        color: ${props => props.status === 'optimized' ? '#13CA82' : '#FFC107'};
        font-size: 2rem;
    }
`;

export const ItemContent = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ItemTitle = styled(Typography)`
    font-weight: bold;
    font-size: 1.1rem;
`;

export const ItemDescription = styled(Typography)`
    font-size: 0.9rem;
    color: #666;
`;

export const ActionContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
    gap: 1rem;
`;

export const ManualEditLink = styled.a`
    color: #0B4598;
    text-decoration: underline;
    cursor: pointer;
    font-size: 0.9rem;

    &:hover {
        color: #FB7672;
    }
`;

export const FixNowButton = styled.button`
    background-color: #0B4598;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 0.4rem 0.8rem;
    font-size: 0.9rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #08336d;
    }
`; 